import React, { Component } from "react";

import { monthName } from "../../../../utils/CommonFunction";

export default class LeaveCarryTargetYear extends Component {
  render() {
    const { yearStart, monthStart, yearEnd, monthEnd } =
      this.props.currentLeaveCarryYears;
    return (
      <div className="col-sm-12" style={{ padding: "10px 10px" }}>
        <div
          className="row col-md-12 margin-top-10"
          style={{
            display: "flex",
            flexWrap: "nowrap",
            alignItems: "center",
          }}
        >
          From
          <span style={{ fontWeight: "bold", fontSize: 14 }}>
            &nbsp;{`${yearStart} ${monthName(monthStart)}`}&nbsp;
          </span>
          : To
          <span style={{ fontWeight: "bold", fontSize: 14 }}>
            &nbsp;{`${yearEnd} ${monthName(monthEnd)}`}
          </span>
        </div>
      </div>
    );
  }
}
